// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.page-button {
  opacity: 0.7;
}
.active {
  opacity: 1.0;
  background: rgba(237, 109, 5, 0.8);
  color: #FEFEFE;
}
  `, "",{"version":3,"sources":["webpack://./src/app/components/device-map/devices-map.ts"],"names":[],"mappings":";;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,kCAAkC;EAClC,cAAc;AAChB","sourcesContent":["\n\n.page-button {\n  opacity: 0.7;\n}\n.active {\n  opacity: 1.0;\n  background: rgba(237, 109, 5, 0.8);\n  color: #FEFEFE;\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
